let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kXuGX")).then(() => parcelRequire('h0bmE'));